var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { stringifyVariables } from '../../utils/stringifyVariables';
import { getNextDefaultBucket } from '../defaults';
import { addBucketIfRequired, } from '../types';
// ---
export function querySchematic(bucketOrOptions, options) {
    var bucket;
    if (!options) {
        options = bucketOrOptions;
        bucket = options.bucket || getNextDefaultBucket();
    }
    else {
        bucket = bucketOrOptions;
    }
    var child = options.for, _a = options.mapVarsToId, mapVarsToId = _a === void 0 ? stringifyVariables : _a, transformInput = options.transformInput;
    return function (vars) {
        return new QuerySchematicImplementation({ root: addBucketIfRequired(bucket, mapVarsToId(vars)) }, child(vars), vars, transformInput);
    };
}
var QuerySchematicImplementation = /** @class */ (function () {
    function QuerySchematicImplementation(selection, child, vars, transformInput) {
        this.selection = selection;
        this.child = child;
        this.vars = vars;
        this.transformInput = transformInput;
    }
    QuerySchematicImplementation.prototype.chunk = function (input) {
        var transformedInput = this.transformInput
            ? this.transformInput(input, this.vars)
            : input;
        var child = this.child.chunk(transformedInput);
        return {
            chunks: child.chunks.concat(__assign(__assign({}, this.selection.root), { payload: { type: 'data', data: child.selection } })),
            selection: this.selection,
        };
    };
    QuerySchematicImplementation.prototype.build = function (selection, pick) {
        var queryResult = pick(selection.root);
        var childResult = queryResult.hasData && this.child.build(queryResult.data, pick);
        return {
            data: childResult ? childResult.data : undefined,
            hasData: childResult && childResult.hasData,
            hasRejection: (childResult && childResult.hasRejection) || queryResult.hasRejection,
            invalidated: queryResult.invalidated || (childResult && childResult.invalidated),
            rejection: childResult ? childResult.rejection : queryResult.rejection,
            pending: queryResult.pending || !!(childResult && childResult.pending),
            primed: queryResult.primed && (!childResult || childResult.primed),
        };
    };
    return QuerySchematicImplementation;
}());
//# sourceMappingURL=querySchematic.js.map